module.exports = __webpack_public_path__ + "static/media/logo.02f7ebf5.png";